import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import styled from 'styled-components';
import ContentTemplate from '../ContentTemplate';

const Error = styled.div`
  background-color: ${props => props.theme.error.backgroundColor};
  padding: ${props => props.theme.error.padding};
  margin: ${props => props.theme.error.margin};
  width: ${props => props.theme.error.width || '100%'};
  height: ${props => props.theme.error.height};
  line-height: ${props => props.theme.error.lineHeight || props.theme.error.height};
  text-align: center;
  color: ${props => props.theme.error.color};
   font-size: 16px;
`;

Error.defaultProps = {
  theme: {
    error: {
      backgroundColor: '#f3f3f3',
      color: '#e8141e',
      height: '49px'
    }
  }
};

class ErrorMessage extends Component {
  static propTypes = {
    hasErrors: PropTypes.bool,
    errorMessage: PropTypes.string.isRequired,
    errorMessageTemplate: PropTypes.string,
    formContext: PropTypes.object,
    location: PropTypes.object
  };

  render () {
    if (!this.props.hasErrors) {
      return null;
    }

    if (this.props.errorMessageTemplate) {
      const contentKey = `errorMessage:${this.props.location?.pathname}`;

      return (
        <ContentTemplate
          html={this.props.errorMessageTemplate}
          formContext={this.props.formContext}
          contentKey={contentKey} />
      );
    }

    return (
      <Error>{this.props.errorMessage}</Error>
    );
  }
}

export default withRouter(ErrorMessage);
